import h from 'hyperscript';
import viewsIcon from '@disy/cadenza-icons/views.svg';

import { createButton } from 'ui/button/button';
import { createPopup, openPopup, PLACEMENT, setupPopupButton } from 'ui/popup/popup';

import { createProcessesContent } from 'cadenza/processes/processes';
import { ProcessesDialog } from 'cadenza/processes/processes-dialog';
import { icon } from 'cadenza/utils/icon/icon';
import { on } from 'cadenza/utils/event-util';
import { mediaXsOnly } from 'cadenza/utils/media';
import { uniqueId } from 'cadenza/utils/unique-id';

import i18n from './messages.properties';

export function createProcessesButton (processesLoader, { menuButton, ...buttonOptions } = {}) {
  const button = createButton([ icon(viewsIcon), h('span.button--label', i18n('processesButton')) ], buttonOptions);
  if (mediaXsOnly.matches) {
    on(button, 'click', () => showProcessesDialog(processesLoader));
  } else if (menuButton) {
    on(button, 'click', () => {
      const popup = createPopup();
      popup.append(createProcessesContent(processesLoader));
      openPopup(menuButton, popup, { placement: PLACEMENT.BOTTOM_START });

      if (!menuButton.id) {
        menuButton.id = uniqueId();
      }

      popup.setAttribute('aria-labelledby', menuButton.id);
      menuButton.setAttribute('aria-controls', popup.id);
      menuButton.setAttribute('aria-expanded', 'true');
    });
  } else {
    setupPopupButton(button, () => createProcessesContent(processesLoader));
  }
  return button;
}

function showProcessesDialog (loader, target) {
  const processesDialog = new ProcessesDialog(loader);
  processesDialog.addEventListener('close', () => processesDialog.remove());
  document.body.append(processesDialog);
  processesDialog.showModal(target);
}
